import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { AuthService } from '../auth-service/auth.service';
import { finalize, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PublicOperationsServiceService } from 'src/app/component/assigned-trips/public-operation/public-operations-service/public-operations.service';
@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  tokenizedReq;
  constructor(private authService: AuthService, private operationService: PublicOperationsServiceService) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime = Date.now();
    const token = this.authService.getToken('token');
    const publicToken = this.operationService.getPublicToken();

    // List of URLs where the Authorization header should be skipped
    const skipAuthorization = [
      '/api/get-server-key'
    ];

    // Check if the current URL is in the skip list
    const shouldSkip = skipAuthorization.some(url => req.url.includes(url));

    let tokenizedReq: any = req;

    if (tokenizedReq.headers.get("Authorization")) {

      if (!shouldSkip) {
        if (req.body instanceof FormData) {
          tokenizedReq = req.clone({
            setHeaders: {
              Authorization: `JWT ${publicToken}`
            }
          });
        } else {

          tokenizedReq = req.clone({
            setHeaders: {
              Authorization: `JWT ${publicToken}`,
              'Content-Type': 'application/json'
            }
          });
        }
      }
    } else {
      if (!shouldSkip) {
        if (req.body instanceof FormData) {
          tokenizedReq = req.clone({
            setHeaders: {
              Authorization: `JWT ${token}`
            }
          });
        } else {

          tokenizedReq = req.clone({
            setHeaders: {
              Authorization: `JWT ${token}`,
              'Content-Type': 'application/json'
            }
          });
        }
      }
    }

    return next.handle(tokenizedReq).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            this.responselogDetails(JSON.stringify(event.body));
          }
        },
        error => {
          this.logDetails('Request failed');
        }
      ),
      finalize(() => {
        const elapsedTime = Date.now() - startTime;
        const message =
          'HttpRequest >>>>>>>>\n\n\n'
          + req.method + ' ' + req.urlWithParams
          + ' in ' + elapsedTime + 'ms'
          + '\nbody: ' + JSON.stringify(req.body)
          + '\n\n\n<<<<<<<< HttpRequest';
        this.logDetails(message);
      })
    );
  }

  private logDetails(msg: string) {
    // console.log(msg);
  }
  private responselogDetails(msg: string) {
    // console.log(' HttpResponse >>>>>>>>\n\n\n' +
    // msg,
    //  '\n\n\n<<<<<<<< HttpResponse');
  }
}
